/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ filtered: NonNullable<unknown>, total: NonNullable<unknown> }} Admin_Resources_Resources_Count_FilteredInputs */

const en_admin_resources_resources_count_filtered = /** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */ (i) => {const totalPlural = registry.plural("en", i?.total, {});
	if (totalPlural == "one") return /** @type {LocalizedString} */ (`${i?.filtered} of ${i?.total} resource`);
	if (totalPlural == "other") return /** @type {LocalizedString} */ (`${i?.filtered} of ${i?.total} resources`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count_filtered");
};

const de_admin_resources_resources_count_filtered = /** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */ (i) => {const totalPlural = registry.plural("de", i?.total, {});
	if (totalPlural == "one") return /** @type {LocalizedString} */ (`${i?.filtered} von ${i?.total} Ressource`);
	if (totalPlural == "other") return /** @type {LocalizedString} */ (`${i?.filtered} von ${i?.total} Ressourcen`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count_filtered");
};

const es_admin_resources_resources_count_filtered = /** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */ (i) => {const totalPlural = registry.plural("es", i?.total, {});
	if (totalPlural == "one") return /** @type {LocalizedString} */ (`${i?.filtered} de ${i?.total} recurso`);
	if (totalPlural == "other") return /** @type {LocalizedString} */ (`${i?.filtered} de ${i?.total} recursos`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count_filtered");
};

const fr_admin_resources_resources_count_filtered = /** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */ (i) => {const totalPlural = registry.plural("fr", i?.total, {});
	if (totalPlural == "one") return /** @type {LocalizedString} */ (`${i?.filtered} sur ${i?.total} ressource`);
	if (totalPlural == "other") return /** @type {LocalizedString} */ (`${i?.filtered} sur ${i?.total} ressources`);
	return /** @type {LocalizedString} */ ("admin.resources.resources_count_filtered");
};

/** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */
const it_admin_resources_resources_count_filtered = en_admin_resources_resources_count_filtered;

/** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */
const pt_br2_admin_resources_resources_count_filtered = en_admin_resources_resources_count_filtered;

/** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */
const pl_admin_resources_resources_count_filtered = en_admin_resources_resources_count_filtered;

/** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */
const hu_admin_resources_resources_count_filtered = en_admin_resources_resources_count_filtered;

/** @type {(inputs: Admin_Resources_Resources_Count_FilteredInputs) => LocalizedString} */
const ro_admin_resources_resources_count_filtered = en_admin_resources_resources_count_filtered;

/**
* | totalPlural | output |
* | --- | --- |
* | "one" | "{filtered} of {total} resource" |
* | "other" | "{filtered} of {total} resources" |
*
* @param {Admin_Resources_Resources_Count_FilteredInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resources_count_filtered = /** @type {((inputs: Admin_Resources_Resources_Count_FilteredInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resources_Count_FilteredInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resources_count_filtered(inputs)
	if (locale === "de") return de_admin_resources_resources_count_filtered(inputs)
	if (locale === "es") return es_admin_resources_resources_count_filtered(inputs)
	if (locale === "fr") return fr_admin_resources_resources_count_filtered(inputs)
	if (locale === "it") return it_admin_resources_resources_count_filtered(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resources_count_filtered(inputs)
	if (locale === "pl") return pl_admin_resources_resources_count_filtered(inputs)
	if (locale === "hu") return hu_admin_resources_resources_count_filtered(inputs)
	return ro_admin_resources_resources_count_filtered(inputs)
});
export { admin_resources_resources_count_filtered as "admin.resources.resources_count_filtered" }